<template>
  <div class="pop">
    <div class="box">
      <div class="top">{{type==1?"用户添加":"用户编辑"}}</div>
      <div class="center">
        <div class="item">
          <span>用户名：</span>
          <span>
            <i-input style="width:200px" v-model="data.name" placeholder="请输入用户名"></i-input>
          </span>
        </div>
        <div class="item">
          <span>登录名：</span>
          <span>
            <i-input style="width:200px" v-model="data.username" placeholder="请输入登录名"></i-input>
          </span>
        </div>
        <div class="item">
          <span>设置密码：</span>
          <span>
            <i-input style="width:200px" v-model="data.password" placeholder="请输入密码"></i-input>
          </span>
        </div>
        <div class="item">
          <span>重复密码：</span>
          <span>
            <i-input style="width:200px" v-model="password" placeholder="请重新输入密码"></i-input>
          </span>
        </div>
        <div class="item">
          <span>角色分配：</span>
          <span>
            <Select v-model="data.group_id" style="width:200px">
              <Option v-for="item in list" :value="item.id" :key="item.id">{{item.title}}</Option>
            </Select>
          </span>
        </div>
      </div>
      <div class="bottom">
        <Button style="margin-right:100px" @click="close">取消</Button>
        <Button type="primary" @click="act">确定</Button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Auths_index,
  User_add,
  User_update,
  User_getInfo
} from "../../assets/js/api.js";
export default {
  data() {
    return {
      list: [],
      data: {
        name: null, //	string	true	普通参数		用户姓名
        username: null, //	string	true	普通参数		登录名
        group_id: null, //	string	true	普通参数		用户组
        password: null //	string	true	普通参数		用户密码
      },
      password: null
    };
  },
  props: ["type", "dataset"],
  mounted() {
    this.getlist();
  },
  methods: {
    init() {
      if (this.type == 2) {
        User_getInfo({ id: this.dataset.id }).then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data[0];
            delete this.data.title;
            delete this.data.createtime;
          }
        });
      }
    },
    close() {
      this.$emit("close");
    },
    getlist() {
      Auths_index().then(res => {
        this.list = res.data.data;
        this.init();
      });
    },
    act() {
      if (!this.data.name) {
        this.errorPlus("用户姓名不能为空！");
        return;
      }
      if (!this.data.username) {
        this.errorPlus("登录名不能为空！");
        return;
      }

      if (!this.data.group_id) {
        this.errorPlus("角色不能为空！");
        return;
      }
      if (this.type == 1) {
        if (!this.data.password) {
          this.errorPlus("密码不能为空！");
          return;
        }
      } else {
        if (!this.data.password) {
          if (confirm("密码不设置将默认为原密码,是否重新设置密码？")) return;
        }
      }
      if (this.password != this.data.password) {
        this.errorPlus("二次输入密码不同！");
        return;
      }
      if (this.type == 1) this.add();
      if (this.type == 2) this.updated();
    },
    add() {
      User_add(this.data).then(res => {
        if (res.data.code == 200) {
          this.$Notice.success({ title: "成功提示", desc: "添加成功！" });
          this.$emit("success");
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    },
    updated() {
      User_update(this.data).then(res => {
        if (res.data.code == 200) {
          this.$Notice.success({ title: "成功提示", desc: "编辑成功！" });
          this.$emit("success");
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    }
  }
};
</script>
<style lang="css" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}
.box {
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
}
.top {
  height: 50px;
  line-height: 50px;
  color: #fff;
  font-size: 18px;
  border-bottom: 1px solid #bbb;
  background: rgb(60, 91, 230);
  border-radius: 10px 10px 0 0;
  text-align: left;
  padding-left: 2em;
}
.item {
  margin-top: 20px;
}
.item span:first-child {
  display: inline-block;
  width: 100px;
  text-align: right;
}
.bottom {
  margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/toast/usermanage.vue